"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("raf/polyfill");
if (typeof fetch === "undefined") {
    require("whatwg-fetch");
}
//# sourceMappingURL=polyfills.js.map